import {BaseComponentLifecycleEventHandler} from "../../infrastructure/handlers/base-component-lifecycle-event-handler";
import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {AppController} from "../app/app-controller";
import {APP, PUSH_NOTIFICATIONS_PERMISSIONS} from "../app/consts";
import {LOCAL_STORAGE_KEYS} from "../consts";
import {LocalStorageUtils} from "../../infrastructure/utils/local-storage.utils";
import {singleton} from "../../infrastructure/decorators/singleton";

@singleton
export class PushNotificationsSubscribeUserHandler extends ActionHandler {
  type = APP.ACTION_TYPES.subscribeUser;
  controller: AppController;
  localStorageUtils: LocalStorageUtils;

  static injectables = [...BaseComponentLifecycleEventHandler.injectables, LocalStorageUtils];

  constructor(localStorageUtils: LocalStorageUtils) {
    super();

    this.isInitialized = false;
    this.localStorageUtils = localStorageUtils;
  }

  async onLoaded() {
    super.onLoaded();

    if(!this.isInitialized) {
      if (this.appStore.state.appNotificationDisplayModel.allowNotifications) {
        let userAllowedNotification;
        if (Notification?.permission === PUSH_NOTIFICATIONS_PERMISSIONS.granted) {
          await this.action();
          userAllowedNotification = true;
        } else if (Notification?.permission === PUSH_NOTIFICATIONS_PERMISSIONS.denied) {
          userAllowedNotification = false;
        }

        this.appStore.state.userAllowedNotification = userAllowedNotification;
      }
    }

    this.isInitialized = true;
  }


  updateSubscription(subscription) {
    const userPushNotificationsSubscription: String = subscription !== null ? JSON.stringify(subscription) : null;

    this.appStore.state.userPushNotificationsSubscription = userPushNotificationsSubscription;
  }

  async isUserSubscribed(): Boolean {
    let isSubscribed;
    const pushNotificationsHandler = this;

    const serviceWorker = await navigator.serviceWorker.ready;
    const subscription = await serviceWorker.pushManager.getSubscription();

    isSubscribed = !(subscription === null);

    pushNotificationsHandler.updateSubscription(subscription);

    console.log('Is user subscribed: ', isSubscribed);
    return isSubscribed;
  }

  async action() {
    const isUserSubscribed = await this.isUserSubscribed();
    this.appStore.state.userAllowedNotification = isUserSubscribed;

    if (!isUserSubscribed && Notification.permission !== 'denied') {
      await this.subscribeUser().then(() => APP.ACTION_TYPES.fetchUsers);
    }
  }

  async subscribeUser() {
    console.log('Subscribing...');
    const publicKey: String = 'BJ2xiL9VmiCD3jtYDh4JHxgeTs9zihiZSXwQrSx6Y9RaCizwigVltxSlRL95moqtc-i0roXYUx83fZhSJ8w4Rwg';

    const pushNotificationsHandler: PushNotificationsSubscribeUserHandler = this;

    const applicationServerKey: String = publicKey.urlB64ToUint8Array();

    await navigator.serviceWorker.ready.then((serviceWorker) => {
      serviceWorker.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey
      })
        .then(function (subscription: PushSubscription) {
          console.log('User is subscribed.');

          pushNotificationsHandler.updateSubscription(subscription);

          pushNotificationsHandler.state.userAllowedNotification = true;
          pushNotificationsHandler.localStorageUtils.set(LOCAL_STORAGE_KEYS.enableNotifications, true)
          pushNotificationsHandler.appStore.state.enableNotifications = true;
        })
        .catch(function (err) {
          console.log('Failed to subscribe the user: ', err);
        });
    });
  }

  async unsubscribeUser() {
    console.log('Unsubscribe...');
    const pushNotificationsHandler = this;

    await navigator.serviceWorker.ready.then((serviceWorker) => {
      serviceWorker.pushManager.getSubscription()
        .then(function (subscription: PushSubscription | null) {
          if (subscription) {
            return subscription.unsubscribe();
          }
        })
        .catch(function (error) {
          console.log('Error unsubscribing', error);
        })
        .then(function () {
          pushNotificationsHandler.updateSubscription(null);

          console.log('User is unsubscribed.');

          pushNotificationsHandler.state.userAllowedNotification = false;
        });
    });
  }
}
